// TODO: delete this component when useImprovedBrandFiltering FF removed
import I18n from 'i18n-js'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from 'tss-react/mui'

import useRouter from '../../../hooks/useRouter'
import colors from '../../../lib/Colors'
import { selectFeaturedPremiumPaidAdData } from '../../../stores/paidAds/selectors'
import ShowMoreButton from '../../shared/ShowMoreButton'
import CampaignCard from '../CampaignCard'
import CampaignGroupHeader from '../CampaignGroupHeader/index'

const useStyles = makeStyles()(() => ({
  noCampaignCard: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: ' center',
  },
  noCampaignsMessageAndCTA: {
    display: 'flex',
    flexDirection: 'column',
    color: colors.gray_300,
  },
  results: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    width: '100%',
    marginBottom: '24px',
  },
  showMore: {
    width: '100%',
  },
}))

const PER_PAGE = 6

const Results = ({ campaigns, onViewOrActivate, show }) => {
  const { featuredAdData } = useSelector(selectFeaturedPremiumPaidAdData)
  let results = []
  for (let i = 0; i < show; i += 1) {
    const campaign = campaigns[i]
    results.push(
      <CampaignCard
        {...campaign}
        cardImage={campaign.thumbnailSrcId}
        index={i}
        isFeatured={featuredAdData.id === campaign.id}
        key={campaign.id}
        onViewOrActivate={onViewOrActivate(campaign)}
      />,
    )
  }
  return results
}

const LegacyPaidAdCampaigns = ({ results }) => {
  const { classes } = useStyles()
  const { push, match } = useRouter()
  const [page, setPage] = useState(1)

  const onViewOrActivateHandler = (campaign) => {
    const activatePath = `/retailer/content/${match.params.retailerAccountSlug}/${match.params.brandSlug}/paid-ad/${campaign.id}`
    return () => {
      push(activatePath)
    }
  }

  const showMoreButtonHandler = () => {
    setPage(page + 1)
  }

  const total = (results && results.length) || 0
  const show = Math.min(total, PER_PAGE * page)

  if (total > 0) {
    return (
      <CampaignGroupHeader
        count={total}
        title={I18n.t('content.paidAdCampaignsHeader')}
      >
        <div className={classes.results}>
          <Results
            campaigns={results}
            onViewOrActivate={onViewOrActivateHandler}
            show={show}
          />
          <div className={classes.showMore}>
            <ShowMoreButton
              numberShown={show}
              onClick={showMoreButtonHandler}
              total={total}
            />
          </div>
        </div>
      </CampaignGroupHeader>
    )
  } else {
    return null
  }
}

export default LegacyPaidAdCampaigns
